module.exports = __webpack_public_path__ + "img/head.fc63e31e.png";